import { React, useState, useEffect } from "react";

const useFieldChange = (initialValue, setChanged) => {
  const [value, setValue] = useState(initialValue);
  const handleChange = (value) => {
    setValue(value);
    setChanged(value === initialValue ? false : true);
  };
  return [value, handleChange];
};

export { useFieldChange };
